import request from '@/utils/request'

// 校园新闻
// 新闻资讯 Campus_news/news
export function news(data) {
  return request({
    method: 'get',
    url: 'Campus_news/news',
    params: data
  })
}

// 校园视频 Campus_news/campusVideo

export function campusVideo(data) {
    return request({
      method: 'get',
      url: 'Campus_news/campusVideo',
      params: data
    })
  }







// WEBPACK FOOTER //
// ./src/api/CampusNews.js